/**
 * Microsoft365Icon/index.js
 * desc: Microsoft 365 product logo without text
 * note: brand icon via IconButton; carries an accessible name (aria-label when interactive) but
 *       no tooltip, matching the brand logos. Renders a button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import './styles.css';


const Microsoft365Icon = (props) => (
    <IconButton baseClassName="microsoft365 icon" label="Microsoft 365" tooltip={ null } { ...props }>
        <svg viewBox="0 0 21 24" xmlns="http://www.w3.org/2000/svg"><path d="M13.35 0C13.32 0 .024 4.816.006 4.834c0 0-.009 3.253-.005 7.215l.007 7.203 1.657-.626c.912-.344 1.929-.728 2.258-.854l.601-.228V11.68c0-4.044.009-5.869.03-5.88.05-.03 8.767-2.035 8.79-2.023.027.017.027 17.231 0 17.247-.012.006-2.986-.383-6.61-.864-3.623-.483-6.597-.875-6.607-.871-.011.004 2.941 1.064 6.56 2.357 3.62 1.293 6.612 2.352 6.65 2.354.037 0 1.72-.438 3.736-.977l3.667-.979-.007-9.999-.007-9.998-3.674-1.024A510.324 510.324 0 0013.35 0z" /></svg>
    </IconButton>
);


export default Microsoft365Icon;
